<script>
export default {
  name: 'OptionListEditor',
  props: {
    modelValue: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: 'Opciones',
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      newOption: '',
    };
  },
  computed: {
    options: {
      get() {
        return this.modelValue || [];
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
  },
  methods: {
    addOption() {
      const trimmed = this.newOption.trim();
      if (trimmed && !this.options.includes(trimmed)) {
        this.options = [...this.options, trimmed];
        this.newOption = '';
      }
    },
    removeOption(index) {
      this.options = this.options.filter((_, i) => i !== index);
    },
    moveUp(index) {
      if (index === 0) return;
      const newOptions = [...this.options];
      [newOptions[index - 1], newOptions[index]] = [newOptions[index], newOptions[index - 1]];
      this.options = newOptions;
    },
    moveDown(index) {
      if (index === this.options.length - 1) return;
      const newOptions = [...this.options];
      [newOptions[index], newOptions[index + 1]] = [newOptions[index + 1], newOptions[index]];
      this.options = newOptions;
    },
  },
};
</script>

<template>
  <div class="option-list-editor">
    <label class="block text-sm font-medium text-n-slate-12 mb-2">
      {{ label }}
    </label>

    <!-- Lista de opciones existentes -->
    <div v-if="options.length > 0" class="space-y-1 mb-3">
      <div
        v-for="(option, index) in options"
        :key="index"
        class="flex items-center gap-2 bg-n-slate-9/5 rounded px-2 py-1.5 group"
      >
        <!-- Botones de reordenar -->
        <div class="flex flex-col gap-0.5">
          <button
            type="button"
            :disabled="index === 0"
            @click="moveUp(index)"
            class="text-n-slate-11 hover:text-n-slate-12 disabled:opacity-30 disabled:cursor-not-allowed"
            :title="$t('MOVE_UP')"
          >
            <fluent-icon icon="chevron-up" size="12" />
          </button>
          <button
            type="button"
            :disabled="index === options.length - 1"
            @click="moveDown(index)"
            class="text-n-slate-11 hover:text-n-slate-12 disabled:opacity-30 disabled:cursor-not-allowed"
            :title="$t('MOVE_DOWN')"
          >
            <fluent-icon icon="chevron-down" size="12" />
          </button>
        </div>

        <!-- Texto de la opción -->
        <span class="flex-1 text-sm text-n-slate-12">{{ option }}</span>

        <!-- Botón eliminar -->
        <button
          type="button"
          @click="removeOption(index)"
          class="text-n-ruby-10 hover:text-n-ruby-11 opacity-0 group-hover:opacity-100 transition-opacity"
          :title="$t('DELETE')"
        >
          <fluent-icon icon="delete" size="16" />
        </button>
      </div>
    </div>

    <!-- Input para agregar nueva opción -->
    <div class="flex gap-2">
      <input
        v-model="newOption"
        type="text"
        placeholder="Nueva opción..."
        class="flex-1 px-3 py-2 text-sm border border-n-weak rounded-md focus:ring-2 focus:ring-n-brand focus:border-n-brand outline-none transition-all bg-white dark:bg-n-solid-2 text-n-slate-12"
        @keydown.enter.prevent="addOption"
      />
      <button
        type="button"
        @click="addOption"
        :disabled="!newOption.trim()"
        class="px-3 py-2 text-sm font-medium text-white bg-n-brand rounded-md hover:bg-n-brand/90 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
      >
        <fluent-icon icon="add" size="16" />
      </button>
    </div>

    <p v-if="options.length === 0" class="text-xs text-n-slate-11 mt-2">
      No hay opciones. Agregue al menos una opción.
    </p>
  </div>
</template>

<style scoped>
/* Estilos adicionales si es necesario */
</style>
